import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { AbTestStateModule, abTestSyncReducer } from '@mkp/ab-test/state';
import { AccountMembershipStateModule } from '@mkp/account-membership/state';
import { AccountStateModule } from '@mkp/account/state';
import { ApplicationStateModule } from '@mkp/application/state';
import { AuthStateModule } from '@mkp/auth/state';
import { CompanyStateModule } from '@mkp/company/state';
import { settingsReducer, VersionStateModule } from '@mkp/core/state';
import { CreditStateModule } from '@mkp/credit/state';
import { createDebugSyncReducer, DebugStateModule } from '@mkp/debug/state';
import { GdprStateModule } from '@mkp/gdpr/state';
import { LayoutStateModule } from '@mkp/layout/state';
import { OnboardingStateModule } from '@mkp/onboarding/state';
import { ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';
import {
  TransientAppCacheStateModule,
  transientAppCacheReducer,
} from '@mkp/transient-app-cache/state';
import { VacancyStateModule } from '@mkp/vacancy/state';
import { LoggedInUserStateModule } from '@mkp/user/state-logged-in';
import { EffectsModule } from '@ngrx/effects';
import { FullRouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { META_REDUCERS, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { effects } from './effects';
import { reducers } from './reducers';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forRoot(reducers, {
      metaReducers: [settingsReducer, abTestSyncReducer, transientAppCacheReducer],
      runtimeChecks: { strictActionTypeUniqueness: true },
    }),
    EffectsModule.forRoot([...effects]),
    StoreRouterConnectingModule.forRoot({
      serializer: FullRouterStateSerializer,
    }),
    AuthStateModule,
    GdprStateModule,
    MatDialogModule,
    TransientAppCacheStateModule,
    DebugStateModule,
    CompanyStateModule,
    LayoutStateModule,
    AbTestStateModule,
    AccountStateModule,
    CreditStateModule,
    AccountMembershipStateModule,
    ApplicationStateModule,
    VersionStateModule,
    OnboardingStateModule,
    VacancyStateModule,
    LoggedInUserStateModule,
  ],
})
export class RootStoreModule {
  static forRoot(
    ngrxDevTools: ModuleWithProviders<StoreDevtoolsModule>[],
    useServiceWorker: boolean
  ): ModuleWithProviders<RootStoreModule> {
    return {
      ngModule: RootStoreModule,
      providers: [
        ...ngrxDevTools.flatMap((module) => module.providers ?? []),
        ...(VersionStateModule.forRoot(useServiceWorker).providers ?? []),
        ...(DebugStateModule.forRoot().providers ?? []),
        {
          provide: META_REDUCERS,
          multi: true,
          useFactory: createDebugSyncReducer,
          deps: [ENVIRONMENT_PROVIDER],
        },
      ],
    };
  }
}
